import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter-on",
  "use": "icon-filter-on-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-filter-on\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"#0091FF\" stroke=\"#0091FF\" d=\"M6.5 7v-.207l-.146-.147L3.207 3.5h8.586L8.646 6.646l-.146.147v6.273l-2-1.334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol